module.exports = import("https://kit.fontawesome.com/ead315ea0a.js");;